import {projectsService} from 'services';
import _ from 'lodash';

_.noConflict();


const projectsStore = {
  namespaced: true,
  state: {
    currentProject: null,

    projectProfiles: []
  },
  getters: {
    currentProject: state => state.currentProject,
    currentProjectId: (state, getters) => getters.currentProject ? getters.currentProject.id : null,

    currentProjectChannels (state, getters) {
      const project = getters.currentProject;
      if (!project) {
        return [];
      }
      return project.placements_channel_ids;
    }
  },
  mutations: {
    SET_CURRENT_PROJECT (state, project) {
      state.currentProject = project;
    },
    SET_PROJECT_PROFILES (state, profiles) {
      state.projectProfiles = profiles;
    }
  },
  actions: {
    async SET_CURRENT_PROJECT_ID (context, projectId) {

      // do not fetch if project is the same
      if (context.getters.currentProjectId === projectId) {
        return;
      }
      if (projectId) {
        return context.dispatch('FETCH_PROJECT', projectId);
      }
      context.dispatch('SET_CURRENT_PROJECT', null);
    },
    async FETCH_PROJECT (context, projectId) {
      const _projectId = projectId || context.getters.currentProjectId;
      if (_projectId) {
        const project = await projectsService.getProjectDetails(context.getters.currentAccountId, _projectId);
        context.dispatch('SET_CURRENT_PROJECT', project);
      }
    },
    async SET_CURRENT_PROJECT (context, project) {
      context.commit('SET_CURRENT_PROJECT', project);
    }
  }
};

export default projectsStore;
